module.exports = __webpack_public_path__ + "static/media/Dell.676775a9.svg";